var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0505 9.4799V24.6266C26.0505 26.5599 24.6638 27.3732 22.9705 26.4399L17.7305 23.5199C17.1705 23.2132 16.2638 23.2132 15.7038 23.5199L10.4638 26.4399C8.77045 27.3732 7.38379 26.5599 7.38379 24.6266V9.4799C7.38379 7.1999 9.25044 5.33325 11.5304 5.33325H21.9038C24.1838 5.33325 26.0505 7.1999 26.0505 9.4799Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0508 13.4932H19.3841",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7168 16.16V10.8267",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveOrderIcon);
export default __webpack_public_path__ + "static/media/save-order-icon.cef5c27e1c6465aa08c67db2d56213fb.svg";
export { ForwardRef as ReactComponent };